<template>
  <a-modal
    :visible="visible"
    @cancel="closeModal"
    :footer="null"
    wrapClassName="share-feed-modal"
    :header="null"
  >
    <div class="share-feed-modal-container">
      <h2 class="share-feed-modal-container__title">Share Post</h2>
      <div class="share-feed-modal-container__body">
        <ManageTopicsRoles
          v-click-outside="handleClickOutside"
          ref="shareModalUsers"
          :userOptions="getFriends"
          module="shareFeedPost"
          @fetchSelectedUser="fetchNewlyAddedTopicMembers"
          @searchUser="searchUser"
          :searchLoader="searchUserLoader"
        />
        <TopicInviteViaEmail
          :topicType="'public'"
          module="shareFeedPost"
          @changeSelectedUsers="updateSelectedEmails"
        />
        <p class="label">Message <span>(optional)</span></p>
        <a-textarea
          v-model:value="sharePostMessage"
          placeholder="Please enter message"
          rows="3"
          class="textarea"
        ></a-textarea>
        <p class="error" v-if="errorMessage">{{ errorMessage }}</p>
      </div>
      <div class="share-feed-modal-container__footer">
        <a-button
          class="btn"
          @click="sharePostsWithOthers()"
          :loading="sharePostModalLoader"
          >Share</a-button
        >
      </div>
    </div>
  </a-modal>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import ManageTopicsRoles from "@/components/BaseComponents/sourcesFilters/ManageTopicsRoles.vue";
import TopicInviteViaEmail from "@/components/BaseComponents/TopicManagement/TopicInviteViaEmail.vue";

export default {
  components: {
    ManageTopicsRoles,
    TopicInviteViaEmail,
  },
  props: {
    visible: {
      type: Boolean,
      default: () => false,
    },
    feed: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    sharePostMessage: "",
    shareFeedMembers: [],
    shareFeedEmails: [],
    errorMessage: null,
    sharePostModalLoader: false,
    searchUserLoader: false
  }),
  computed: {
    ...mapGetters({
      getFriends: "profile/getFriends",
    }),
    isFormValid() {
      return this.shareFeedMembers.length !== 0 ||
        this.shareFeedEmails.length !== 0
        ? true
        : false;
    },
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          const parentElement = this.$refs.shareModalContainer;
          if (parentElement) {
            // console.log("PARENT ELEMENT", parentElement)
            this.$refs.shareModalContainer.addEventListener(
              "click",
              (event) => {
                // used to handle click inside of this component
                const element = this.$refs.shareModalUsers;
                const className =
                  "manage-topics-roles-section__section--search-users-dropdown";

                if (element) {
                  if (element.$el.contains(event.target)) {
                    const targetElement = event.target;

                    // Check if the clicked element or any of its ancestors has the specific class
                    if (
                      targetElement.classList.contains(className) ||
                      targetElement.closest(`.${className}`)
                    ) {
                      //pass
                    } else {
                      // If clicked outside of the element or inside it but without the class, hide the dropdown
                      element.hideDropdown(); // Assuming element has the hideDropdown method
                    }
                  } else {
                    element.hideDropdown();
                  }
                }
              }
            );
          }

          (async () => {
            await this.$store.dispatch("profile/getFriendsList", {userId:this.$store.getters["auth/getUserId"]});
          })();
        } else {
          this.clearAllFields();
        }
      },
    },
  },
  methods: {
    ...mapActions({
      sharePost: "feed/sharePost",
    }),
    closeModal() {
      this.$emit("closeShareModal");
    },
    handleClickOutside() {
      // used to handle click out side of this component
      const element = this.$refs.shareModalUsers;
      if (element) {
        element.hideDropdown();
      }
    },
    fetchNewlyAddedTopicMembers(users) {
      this.shareFeedMembers = [...users];
    },
    updateSelectedEmails(users) {
      this.shareFeedEmails = [...users];
    },
    async sharePostsWithOthers() {
      this.errorMessage = null;
      if (!this.isFormValid) {
        this.errorMessage = "Please select a user or type in an email";
        return;
      }
      try {
        this.sharePostModalLoader = true;
        const glocalUserList = this.shareFeedMembers.map((user) => ({
          to_user: user?.id,
          message: this.sharePostMessage,
          link: `${process.env.VUE_APP_REDIRECTION_URL}/network-feed/?feed=${this.feed?.id}`,
        }));

        const emailList = this.shareFeedEmails.map((user) => ({
          to_email: user?.email,
          message: this.sharePostMessage,
          link: `${process.env.VUE_APP_REDIRECTION_URL}/network-feed/?feed=${this.feed?.id}`,
        }));

        await this.sharePost({
          postId: this.feed?.id,
          sharedList: [...glocalUserList, ...emailList],
        });

        this.$showToast({
          message: "Post shared successfully.",
          type: "success",
        });
      } catch (err) {
        console.log(err);
        this.$showToast({
          message: "Something went wrong. Please try again later.",
          type: "failure",
        });
      } finally {
        this.closeModal();
      }
    },
    clearAllFields() {
      this.sharePostModalLoader = false;
      this.sharePostMessage = "";
      this.shareFeedMembers = [];
      this.shareFeedEmails = [];
      this.errorMessage = null;
      this.emitter.emit("clear-manage-topic-roles");
      this.emitter.emit("clear-topic-invited-emails");
    },
    async searchUser(searchValue) {
      try{
        this.searchUserLoader = true
        await this.$store.dispatch("profile/getFriendsList", {userId:this.$store.getters["auth/getUserId"], searchName:searchValue});
        this.searchUserLoader = false
      }
      catch(err){
        //pass
      }finally{
        this.searchUserLoader = false
      }
    }
  },
};
</script>
<style lang="scss">
.share-feed-modal {
  .ant-modal {
    width: 50rem !important;
    top: 8rem;
  }
  .ant-modal-content {
    padding: 0;
    box-shadow: 0px 0px 94px #00000047;
    background: #f6f8ff;
    border-radius: 0;
    .ant-modal-close {
      margin: 2.5rem 1.7rem 0 0;
    }
    .ant-modal-header {
      display: none;
    }
    .ant-modal-body {
      .share-feed-modal-container {
        &__title {
          font-size: 2.4rem;
          font-family: $font-secondary-bold;
          line-height: normal;
          margin-bottom: 0;
          padding: 2.5rem 2.5rem 2.8rem;
          color: $color-black;
        }
        &__body {
          padding: 0 2.5rem 2.5rem;
          height: max-content;
          max-height: calc(100vh - 32rem);
          overflow-y: auto;
          overflow-x: hidden;
          &::-webkit-scrollbar-track {
            background-color: transparent;
          }

          &::-webkit-scrollbar {
            width: 0.4rem;
            background-color: transparent;
            border-radius: 3rem;
          }

          &::-webkit-scrollbar-thumb {
            background-color: $color-primary;
            border-radius: 3rem;
          }
          .manage-topics-roles-section {
            margin: 0;
          }
          .textarea {
            border: 1px solid $color-dark-grey-4;
            font-size: 1.4rem;
            font-family: $font-primary;
            outline: none;
            border-radius: 0.5rem;
            color: $color-black;
            padding: 1rem;
            box-shadow: none;
            resize: none;
            &::placeholder {
              color: $color-placeholder;
            }
          }
        }
        .label {
          font-size: 1.6rem;
          font-family: $font-primary-medium;
          margin-bottom: 1rem;
          line-height: 2.2rem;
          width: fit-content;
          color: $color-black;
          span {
            opacity: 0.6;
          }
        }
        .error {
          color: red;
          font-size: 1.5rem;
          font-family: $font-secondary;
          margin: 0.5rem 0 1rem;
        }
        &__footer {
          padding: 2.5rem;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .btn {
            font-size: 1.6rem;
            font-family: $font-primary-medium;
            width: 10rem;
            display: block;
            height: 4rem;
            border: none;
            background-color: $color-primary;
            color: $color-white;
            padding: 0;
            span {
              line-height: 1rem;
            }
            .anticon {
              .anticon-spin {
                font-size: 2rem;
                color: $color-primary;
              }
            }
          }
        }
      }
    }
  }
}
</style>
